import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import BanksLoading from '../_componentWithRedirect/steps/banksLoading.mdx';
import BanksRetrieved from '../_componentWithRedirect/steps/banksRetrieved.mdx';
import KlarnaPaymentSessionCreated from '../_klarna/steps/klarnaPaymentSessionCreated.mdx';
import KlarnaPaymentViewLoaded from '../_klarna/steps/klarnaPaymentViewLoaded.mdx';
import KlarnaPaymentSessionAuthorized from '../_klarna/steps/klarnaPaymentSessionAuthorized.mdx';
import KlarnaPaymentSessionFinalized from '../_klarna/steps/klarnaPaymentSessionFinalized.mdx';
import AchUserDetailsRetrieved from '../_ach/steps/achUserDetailsRetrieved.mdx';
import AchUserDetailsCollected from '../_ach/steps/achUserDetailsCollected.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title='onStep' subtitle={`(data: ${props.parameterType}) => void`} mdxType="Item">
      <p>{`Called whenever the component emits a new step. This usually happens when calling `}<a href={`${props.startUrl}`}>start</a> or <a href={`${props.submitUrl}`}>{`submit`}</a>{` or whenever the component collects data.`}</p>
      <Group summary='Parameters' mdxType="Group">
    {props.parameters === 'adyen-ideal' && <BanksLoading mdxType="BanksLoading" />}
    {props.parameters === 'adyen-ideal' && <BanksRetrieved mdxType="BanksRetrieved" />}
    {props.parameters === 'klarna' && <KlarnaPaymentSessionCreated mdxType="KlarnaPaymentSessionCreated" />}
    {props.parameters === 'klarna' && <KlarnaPaymentViewLoaded mdxType="KlarnaPaymentViewLoaded" />}
    {props.parameters === 'klarna' && <KlarnaPaymentSessionAuthorized mdxType="KlarnaPaymentSessionAuthorized" />}
    {props.parameters === 'klarna' && <KlarnaPaymentSessionFinalized mdxType="KlarnaPaymentSessionFinalized" />}
    {props.parameters === 'ach' && <AchUserDetailsRetrieved mdxType="AchUserDetailsRetrieved" />}
    {props.parameters === 'ach' && <AchUserDetailsCollected mdxType="AchUserDetailsCollected" />}
      </Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      